import { useState } from "react";
import { useSite } from "../context/SiteContext";
import { useWhatsNew } from "../hooks/useWhatsNew";
import WhatsNewModal from "./WhatsNewModal";
import GdprModal from "./GdprModal";
import Footer from "./Footer";

function WhatsNewController() {
  const { sites, loadingSites } = useSite();
  const isSiteManager = sites.some((s) => s.user_role !== "gate_opener");

  // wait for the sites: the role decides between popup and silent version update
  const { showModal, versions, handleClose, openModal } = useWhatsNew(isSiteManager, !loadingSites);
  const [showGdpr, setShowGdpr] = useState(false);

  return (
    <>
      <Footer
        onVersionClick={isSiteManager ? openModal : null}
        onGdprClick={() => setShowGdpr(true)}
      />
      <WhatsNewModal show={showModal} versions={versions} onClose={handleClose} />
      <GdprModal show={showGdpr} onClose={() => setShowGdpr(false)} />
    </>
  );
}

export default WhatsNewController;
